// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6233fc51","118":"414146b3","188":"5bf018d7","330":"9e84b9d3","361":"6dfdfff3","453":"3cb1ae6e","462":"7264de8f","569":"e0260b5c","669":"236cb844","784":"68501cbd","900":"b17bd339","939":"28284c2a"}[chunkId] + ".chunk.js";
};